import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
export function PricingSection() {
  return <section id="oferta" className="py-12 bg-main relative overflow-hidden" data-id="element-148">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-149">
        <div className="max-w-lg mx-auto bg-card p-1 shadow-xl border border-[#D9D0C1]" data-id="element-150">
          <div className="bg-card p-8 md:p-12" data-id="element-151">
            <div className="text-center mb-8" data-id="element-152">
              <h2 className="text-3xl md:text-4xl font-serif text-title mb-2" data-id="element-153">
                Lo que recibes hoy:
              </h2>
              <div className="flex items-center justify-center mt-6 mb-2" data-id="element-154">
                <span className="text-body line-through text-xl mr-3" data-id="element-155">97€</span>
                <span className="text-5xl font-serif text-title" data-id="element-156">19€</span>
              </div>
              <p className="text-body text-sm font-medium" data-id="element-157">
                Pago único • Acceso inmediato • Digital
              </p>
            </div>

            <div className="space-y-4 mb-10" data-id="element-158">
              {['Método Faceless Spain (PDF 30 páginas)', 'Checklist de Lanzamiento Faceless (PDF)', 'Guiones DM Faceless — Copia y Pega (PDF)', 'Acceso inmediato', 'Garantía 14 días'].map((item, index) => <div key={index} className="flex items-start" data-id="element-159">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-alt flex items-center justify-center mt-0.5 mr-3 border border-[#D9D0C1]" data-id="element-160">
                    <Check size={12} className="text-accent" data-id="element-161" />
                  </div>
                  <span className="text-title text-sm" data-id="element-162">{item}</span>
                </div>)}
            </div>

            <Button className="w-full justify-center text-lg py-4" withArrow data-id="element-163">
              Acceder al PDF
            </Button>

            <p className="text-center text-xs text-body mt-4" data-id="element-164">
              Pago único • PDF (30 páginas) • Acceso inmediato • Garantía 14
              días
            </p>
          </div>
        </div>
      </div>
    </section>;
}